export enum NameCurrentProcessNdService{
    ProcessStart,
    FetchFromGit,
    StopService,
    FolderClear,
    FolderCopy,
    StartService
}